module.exports = __webpack_public_path__ + "img/clipboard.abf24f3f.svg";